<template>
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">Indications</h3>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <p v-if="status != null && status != ''">
            <span v-if="typeof status.processed !== 'undefined'"
              >You have successfully uploaded {{ status.processed }} new
              indications.</span
            >
            <span v-if="typeof status.errors !== 'undefined'">
              There are also {{ status.errors }} error from this upload.
            </span>
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th scope="col">Row</th>
                  <th scope="col">Reason</th>
                  <th scope="col">Date</th>
                  <th scope="col">Block/House No.</th>
                  <th scope="col">Street Name</th>
                  <th scope="col">Unit No.</th>
                  <th scope="col">Project Name</th>
                  <th scope="col">Postal Code</th>
                  <th scope="col">Property Type</th>
                  <th scope="col">Tenure</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in uploads" :key="index">
                  <td>{{ index + 2 }}</td>
                  <td>{{ item.error }}</td>
                  <td>{{ item.created_at | formatDate }}</td>
                  <td>{{ item.house_no }}</td>
                  <td>{{ item.street_name }}</td>
                  <td>{{ item.unit_no }}</td>
                  <td>{{ item.project }}</td>
                  <td>{{ item.postal_code }}</td>
                  <td>
                    <span v-if="item.config != null">{{
                      item.config.config.value
                    }}</span>
                  </td>
                  <td>{{ item.tenure_type }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="pull-right">
            <button
              type="button"
              class="btn btn-primary"
              @click="downloadExcel"
            >
              Download Errors
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  data() {
    return {
      uploads: [],
      status: {},
    };
  },
  methods: {
    downloadExcel() {
      this.$parent.$refs.progressModal.show();
      this.$http({
        url: this.rootUrl + "indication/export-error",
        method: "POST",
        responseType: "blob",
        data: {
          ids: [],
        },
      }).then((response) => {
        this.refreshToken(response);
        const blob = new Blob([response.data], {
          type: response.data.type,
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        // const contentDisposition = response.headers["content-disposition"];
        let fileName = "errors.xlsx";
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        this.$parent.$refs.progressModal.hide();
      });
    },
  },
  mounted() {
    if (
      typeof this.$route.query.id !== "undefined" &&
      this.$route.query.id != null
    ) {
      this.$http
        .get(
          this.rootUrl + "indication/errors/" + this.$route.query.id,
          this.corsConfig
        )
        .then(
          (res) => {
            this.refreshToken(res);
            this.status = res.data;

            this.$http
              .post(this.rootUrl + "indication/errors", {
                id: this.$route.query.id,
              })
              .then(
                (res) => {
                  this.refreshToken(res);
                },
                (err) => {
                  this.$snotify.error(err.response.data.message, "Valuation", {
                    timeout: 4000,
                    showProgressBar: false,
                    position: "rightTop",
                  });
                }
              );
          },
          (err) => {
            this.$snotify.error(err.response.data.message, "Valuation", {
              timeout: 4000,
              showProgressBar: false,
              position: "rightTop",
            });
          }
        );
    }

    this.$http.post(this.rootUrl + "indication/uploads", {}).then(
      (res) => {
        this.refreshToken(res);
        this.uploads = res.data;
      },
      (err) => {
        this.$snotify.error(err.response.data.message, "Valuation", {
          timeout: 4000,
          showProgressBar: false,
          position: "rightTop",
        });
      }
    );
  },
};
</script>
